import { render, staticRenderFns } from "./withdrawDetail.vue?vue&type=template&id=673f2bf4&scoped=true&"
import script from "./withdrawDetail.vue?vue&type=script&lang=js&"
export * from "./withdrawDetail.vue?vue&type=script&lang=js&"
import style0 from "./withdrawDetail.vue?vue&type=style&index=0&id=673f2bf4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "673f2bf4",
  null
  
)

export default component.exports